// extracted by mini-css-extract-plugin
export default {"team_header":"TeamHeaderPhase2-9_team_header_a1GX_"};